export interface AppConfig {
  NODE_ENV: string;
  ADMIN_UI_GTM_KEY: string;
  REPORT_UI_GTM_KEY: string;
  ADMIN_API_CLIENT_URL: string;
  AUTH_API_CLIENT_URL: string;
  ADMIN_UI_URL: string;
  REPORT_UI_URL: string;
  GROWTHBOOK_API_KEY: string;
  DATADOG_AUTH_UI_CLIENT_TOKEN: string;
  DATADOG_AUTH_UI_RUM_APPLICATION_ID: string;
  DATADOG_AUTH_UI_RUM_DEFAULT_PRIVACY_LEVEL: string;
  DATADOG_AUTH_UI_RUM_SESSION_REPLAY_SAMPLE_RATE: string;
  DATADOG_AUTH_UI_RUM_SESSION_SAMPLE_RATE: string;
}

/**
 * Get app config. During development is uses values from env variables.
 * On prod it return global config object
 *
 * This enables single Docker image build to be run with different configs.
 */
export const getAppConfig = (): AppConfig => {
  /**
   * In development use env variables
   */
  if (process.env.NODE_ENV === 'development') {
    return {
      NODE_ENV: process.env.NODE_ENV,
      ADMIN_UI_GTM_KEY: process.env.ADMIN_UI_GTM_KEY,
      REPORT_UI_GTM_KEY: process.env.REPORT_UI_GTM_KEY,
      ADMIN_API_CLIENT_URL: process.env.ADMIN_API_CLIENT_URL,
      AUTH_API_CLIENT_URL: process.env.AUTH_API_CLIENT_URL,
      ADMIN_UI_URL: process.env.ADMIN_UI_URL,
      REPORT_UI_URL: process.env.REPORT_UI_URL,
      GROWTHBOOK_API_KEY: process.env.GROWTHBOOK_API_KEY,
      DATADOG_AUTH_UI_CLIENT_TOKEN: process.env.DATADOG_AUTH_UI_CLIENT_TOKEN,
      DATADOG_AUTH_UI_RUM_APPLICATION_ID: process.env.DATADOG_AUTH_UI_RUM_APPLICATION_ID,
      DATADOG_AUTH_UI_RUM_DEFAULT_PRIVACY_LEVEL:
        process.env.DATADOG_AUTH_UI_RUM_DEFAULT_PRIVACY_LEVEL,
      DATADOG_AUTH_UI_RUM_SESSION_REPLAY_SAMPLE_RATE:
        process.env.DATADOG_AUTH_UI_RUM_SESSION_REPLAY_SAMPLE_RATE,
      DATADOG_AUTH_UI_RUM_SESSION_SAMPLE_RATE: process.env.DATADOG_AUTH_UI_RUM_SESSION_SAMPLE_RATE,
    } as AppConfig;
  }

  if (!window || !window.AppConfig) {
    throw new Error('APP CONFIG MISSING!');
  }

  const appConfigShallowCopy = {
    ...window.AppConfig,
  } as AppConfig;

  return appConfigShallowCopy;
};
